module.exports = __webpack_public_path__ + "static/img/call_menu_title.abe42b27.svg";